module.exports = __webpack_public_path__ + "static/media/consumer-power-desktop.480b218e.jpg";